<template>
    <div class="new-account md-layout md-alignment-top-center">
        <md-card class="md-layout-item md-size-65">
            <md-card-header>
                <h1 class="md-title">New Account</h1>
            </md-card-header>
            <md-card-content>
                <div>
                    <span class="md-subheading">Account type: </span>
                    <md-radio v-model="accountType" value="Student">Student</md-radio>
                    <md-radio v-model="accountType" value="Other">Other</md-radio>
                </div>
                <div class="md-layout md-gutter md-alignment-center" v-if="accountType === 'Student'">
                    <div class="md-layout-item md-size-60">
                        <md-autocomplete
                        ref="auto1"
                            class="search"
                            :class="{'md-invalid': accountExists}"
                            v-model="accountName"
                            :md-options="studentNames"
                            :md-open-on-focus="false">
                            <label>Account Name</label>
                            <span class="md-error">Account Already Exists</span>
                        </md-autocomplete>
                    </div>
                    <div class="md-layout-item md-size-20">
                        <md-field :class="{'md-invalid': deposit < 0}">
                            <label>Initial Deposit</label>
                            <span class="md-prefix">$</span>
                            <md-input  v-model.number="deposit" type="number"></md-input>
                            <span class="md-error">Deposit must be positive</span>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-20">
                        <md-field :class="{'md-invalid': limit <= 0}">
                            <label>Withdrawl Limit</label>
                            <span class="md-prefix">$</span>
                            <md-input  v-model.number="limit" type="number"></md-input>
                            <span class="md-error">Limit must be positive</span>
                        </md-field>
                    </div>
                </div>
                <div class="md-layout md-gutter" v-else>
                    <div class="md-layout-item md-size-40">
                        <md-field :class="{'md-invalid': accountExists}">
                            <label>Account Name</label>
                            <md-input v-model="accountName"></md-input>
                            <span class="md-error">Account exists</span>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-40">
                        <md-autocomplete
                        ref="auto2"
                            class="search"
                            v-model="authorizedUser"
                            :md-options="facultyNames"
                            :md-open-on-focus="false">
                            <label>Authorized User</label>
                            <span class="md-helper-text">You can add more users later</span>
                        </md-autocomplete>
                    </div>
                    <div class="md-layout-item md-size-20">
                        <md-field :class="{'md-invalid': deposit < 0}">
                            <label>Initial Deposit</label>
                            <span class="md-prefix">$</span>
                            <md-input  v-model.number="deposit" type="number"></md-input>
                            <span class="md-error">Deposit must be positive</span>
                        </md-field>
                    </div>
                </div>
            </md-card-content>
            <md-card-actions>
                <md-button class="md-accent" @click="saveAccount()" :disabled="!enableSave">Save</md-button>
            </md-card-actions>
        </md-card>
        <md-snackbar md-position="left" :md-duration="5000" :md-active.sync="showSnackbar" md-persistent>
            <span>Account Created</span>
            <md-button class="md-primary" @click="showSnackbar = false" :to="`/detail/${lastAccountID}`">View</md-button>
        </md-snackbar>
    </div>
</template>
<script>
 import {db} from '@/db';
 import { mapGetters } from 'vuex';
 let accountsRef = db.ref('bankAccounts');
export default {
    name:"newAccount",
    data: ()=>({
        accountType: "Student",
        authorizedUser: null,
        accountName: null,
        deposit: 0,
        limit: 50,
        showSnackbar: false,
        lastAccountID: null
    }),
    computed: {
     ...mapGetters(['students', 'studentNames', 'staff', 'accountNames', 'currentBankBalance']),
      
      selectedStudent: function(){
        let i = this.studentNames.indexOf(this.accountName);
        let obj = this.students[i];
        delete obj['.key']
        return obj;
      },
      facultyNames:function(){
        return this.staff.map(obj => obj.name);
      },
      selectedFaculty: function(){
        let i = this.facultyNames.indexOf(this.authorizedUser);
        let obj = this.staff[i];
        delete obj['.key']
        return obj
      },
      accountExists: function(){
        return this.accountNames.includes(this.accountName)
        },
      enableSave: function(){
          return (!this.accountExists && this.accountName && this.deposit > 0)
      },
    },
    methods:{
        //TODO: test out non-student account
        saveAccount(){
            let account = {
                name: this.accountName,
                balance: this.deposit,
                type: this.accountType,
                deposits: 1,
                withdrawls: 0,
                archived: false,
                created: new Date().toISOString()
            }
            if(this.accountType === 'Student'){
                account.ID = this.selectedStudent.ID;
                account.email = this.selectedStudent.email;
                account.limit = this.limit;
                accountsRef.child(account.ID).set(account);
                this.lastAccountID = account.ID;
                db.ref('bankTransactions').push({
                    ID: account.ID,
                    accountName: account.name,
                    timestamp: new Date().toIsoString(),
                    accountBalance: this.deposit,
                    amount: this.deposit,
                    bankBalance: this.currentBankBalance + this.deposit,
                }).then(()=>{
                    this.accountName = '';
                    this.$refs.auto1.$el.getElementsByClassName('md-input')[0].blur();
                    this.deposit = 0;
                    this.limit = 50;
                    this.showSnackbar = true;
                })
                
                
            }
            else{
                account.authorizedUsers = {};
                account.authorizedUsers[this.selectedFaculty.ID] = this.selectedFaculty;
                accountsRef.push(account).then(docRef => {
                    docRef.update({ID: docRef.key});
                    this.lastAccountID = docRef.key;
                    db.ref('bankTransactions').push({
                    ID: docRef.key,
                    accountName: account.name,
                    amount: this.deposit,
                    timestamp: new Date().toIsoString(),
                    accountBalance: this.deposit,
                    bankBalance: this.currentBankBalance + this.deposit
                }).then(()=>{
                    this.accountName = '';
                    this.authorizedUser = '';
                    this.$refs.auto2.$el.getElementsByClassName('md-input')[0].blur();
                    this.deposit = 0;
                    this.account = null;
                    this.showSnackbar = true;
                    this.accountType = 'Student';
                })    
            })
            }
        },
    }
    
}
</script>

